export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14195.5f49a5c5.jpg";